module.exports = __webpack_public_path__ + "static/media/6.c2ba458a.JPG";